import React, {useState, useCallback} from 'react';
import { useForm } from 'react-hook-form';
import { useMutation } from '@apollo/client';
import DataState from 'app/src/components/DataState';
import Input from 'app/src/elements/inputs';
import { Button, ButtonGroup } from 'app/src/elements/buttons';
import { View } from 'react-native';
import { CREATE_SELLER } from './queries';
import { ButtonContainer } from './elements';
import { RELEASE_OPTIONS } from '.';
import { useParams } from 'react-router-dom';


const NewSeller = ({setShowModal, refetch}) => {
  const [submitting, setSubmitting] = useState();
  const [createSeller] = useMutation(CREATE_SELLER, {
    onCompleted: () => {
      refetch();
      setShowModal(false);
    }
  });

  const onSubmit = useCallback(input => {
    setSubmitting(true);
    if (!input.releaseOption) { input.releaseOption = null; }
    createSeller({ variables: input });
  });

  const { control, handleSubmit, register, watch, formState: { errors } } = useForm({
    defaultValues: {
      name: '',
      companyName: '',
      street: '',
      city: '',
      state: '',
      postalCode: '',
      phoneNumber: '',
      feeType: 'Percent',
      feeAmount: '0',
      releaseOption: '',
      canAddAsset: false,
      showDatePaid: false,
      inspectionFeeAmount: '0',
    }
  });

  const watchFeeType = watch('feeType');

  return (
    <View>
      {/* <SubNav /> */}
      {submitting ?
        <DataState.Loading /> :
        <View>
          <Input.Text
            label="Name:"
            name="name"
            control={control}
            errors={errors}
          />
          <Input.Text
            label="Company Name:"
            hint="At least one of name or company name is required."
            name="companyName"
            control={control}
            errors={errors}
          />
          <Input.Text
            label="Street:"
            name="street"
            control={control}
            errors={errors}
          />
          <Input.Text
            label="City:"
            name="city"
            control={control}
            errors={errors}
          />
          <Input.StatePicker
            label="State:"
            name="state"
            control={control}
            errors={errors}
          />
          <Input.Text
            label="Zip:"
            name="postalCode"
            control={control}
            errors={errors}
          />
          <Input.Phone
            label="Phone Number:"
            name="phoneNumber"
            control={control}
            errors={errors}
          />
          <Input.Picker
            label="Seller Fee Type:"
            name="feeType"
            control={control}
            errors={errors}
            options={['Percent', 'Flat Fee'].map(option => {
              return {value: option, label: option}
            })}
            {...register('feeType', { required: 'Required' })}
          />
          <Input.Number
            label={
              `Seller Fee ${'Flat Fee' === watchFeeType ? 'Amount' : '%'}:`
            }
            name="feeAmount"
            control={control}
            errors={errors}
            {...register('feeAmount', { required: 'Required' })}
          />
          <Input.Number
            label={
              `Inspection Fee Amount:`
            }
            name="inspectionFeeAmount"
            control={control}
            errors={errors}
          />
          <Input.Picker
            label="Release Option"
            name="releaseOption"
            control={control}
            errors={errors}
            options={
              RELEASE_OPTIONS.map(option => {
                return {value: option, label: option}
              })
            }
            {...register('releaseOption', { required: 'Required' })}
          />
          <Input.Checkbox
            label="Can This Seller Add Own Assets?"
            name="canAddAsset"
            control={control}
            errors={errors}
          />
          <Input.Checkbox
            label="Should this Seller see the Date Paid?"
            name="showDatePaid"
            control={control}
            errors={errors}
          />
          <ButtonContainer>
            <ButtonGroup>
              <Button label="Create Seller" onPress={handleSubmit(onSubmit)} />
            </ButtonGroup>
          </ButtonContainer>
        </View>
      }
    </View>
  )
}

export default NewSeller;
